import React, { useCallback, useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { getStationsApi } from "../../../../services/stations";

type Props = {
  value: string[];
  onChange: (stations: string[]) => void;
};

const StationsMultiSelectOps: React.FC<Props> = ({ value, onChange }) => {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getStationsApi("COCHARGE");
      setOptions(data?.map((st: { id: string }) => st.id) ?? []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <MultiSelect
      value={value}
      options={options}
      onChange={(e) => onChange(e.value)}
      placeholder={loading ? "Loading stations..." : "Select stations"}
      disabled={loading}
      filter
      showSelectAll={false}
      className="w-full"
      display="chip"
    />
  );
};

export default StationsMultiSelectOps;
